import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'groupArray' })
export class GroupPipe implements PipeTransform {
    transform(value, args: any): any {
        for (let field in value) {
            if (field == args) {
               var returnArray= _.uniqBy(value[args], 'category');
                return returnArray;
            }
        }

    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/listGroupArray.pipe.ts